import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { push } from 'react-router-redux';
import { PsRoutes } from '../../shared/routing/Routes';
import CompaniesRequest from '../../company/ws/CompaniesRequest';
import AddCompanyRequest from '../../company/ws/AddCompanyRequest';
import UpdateCompanyRequest from '../../company/ws/UpdateCompanyRequest';
import CompanyRequest from '../../company/ws/CompanyRequest';
import CompanyWorksRequest from '../ws/CompanyWorksRequest';
import RouterUtils from '../../shared/routing/RouterUtils';
import { EXPORT_DOCUMENTS_CLEAR } from './exportOutsourceDocsActions';
import * as sha256 from 'sha256';
import CompanyAssociationAdd from '../ws/CompanyAssociationAdd';

// CONSTANTS
export const OUTSOURCES_UPDATE = 'outsources-update';
export const OUTSOURCES_LOADING = 'outsources-loading';
export const OUTSOURCES_ERROR = 'outsources-error';
export const OUTSOURCE_UPDATE = 'outsource-update';
export const OUTSOURCE_ASSIGNMENT_DISPLAY = 'outsource-assignment-display';
export const OUTSOURCE_ASSIGNMENT_LOADING = 'outsource-assignment-loading';
export const OUTSOURCE_REMOVE = 'outsource-remove';
export const OUTSOURCE_ERROR = 'outsource-error';
export const OUTSOURCE_LOADING = 'outsource-loading';
export const OUTSOURCE_WORKS_UPDATE = 'outsource-works-update';
export const OUTSOURCE_WORKS_LOADING = 'outsource-works-loading';
export const OUTSOURCE_WORKS_CLEAN = 'outsource-works-clean';

// ACTIONS

export const getCompanies = (page = 1, search = '', showOnlyActive = null) => (dispatch) => {

    new CompaniesRequest(page, search, true, showOnlyActive)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCES_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: OUTSOURCES_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: OUTSOURCES_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCES_LOADING, payload: false });
        })
        .execute();
};

export const getCompaniesDeleted = (page = 1, search = '') => (dispatch) => {

    new CompaniesRequest(page, search, true, true, true)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCES_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: OUTSOURCES_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: OUTSOURCES_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCES_LOADING, payload: false });
        })
        .execute();
};

export const getCompany = (id) => (dispatch) => {
    new CompanyRequest(id)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: OUTSOURCE_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({
                type: OUTSOURCE_ERROR,
                payload: error,
            });
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: false });
        })
        .execute();
};

export const goToAddOutsource = () => (dispatch) => {
    dispatch(push(PsRoutes.MY_OUTSOURCES_ADD));
};

export const goToExportDocs = (outsourceId) => (dispatch) => {
    dispatch({ type: EXPORT_DOCUMENTS_CLEAR });
    dispatch(push(RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT, { id: outsourceId })));
};

export const addCompany = (company = {}) => (dispatch) => {

    const documentSchemaId =
        company.document_schema_id &&
        company.document_schema_id !== -1 &&
        company.document_schema_id.length !== 0 ?
            company.document_schema_id[0].value :
            undefined;

    const documentSchemaMonthlyId =
        company.document_schema_monthly_id &&
        company.document_schema_monthly_id !== -1 &&
        company.document_schema_monthly_id.length !== 0 ?
            company.document_schema_monthly_id[0].value :
            undefined;

    const companySave = {
        id: undefined,
        name: company.name,
        nif: company.nif,
        contact_person: company.contact_person,
        phone: company.phone,
        email: company.email,
        address: company.address,
        ccc: company.ccc,
        disabled: false,
        document_schema_id: documentSchemaId,
        document_schema_monthly_id: documentSchemaMonthlyId,
        user_email: company.user_email,
        user_plain_password: company.user_password,
        user_password: ( company.user_password && company.user_password.length !== 0 ) && sha256(company.user_password),
    };

    new AddCompanyRequest(companySave)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: true });
        })
        .onSuccess(res => {
            Alert.success(I18nUtils.tr('TR_ADD_OUTSOURCE_SUCCESS'));
            dispatch(push(PsRoutes.MY_OUTSOURCES));
        })
        .onFail(error => {
            switch ( error ) {
                case 'Ya existe una empresa similar en otro contratista, ¿deseas enviar una petición de colaboración?':
                    const payload = { displayDialog: true, nif: company.nif };
                    dispatch({ type: OUTSOURCE_ASSIGNMENT_DISPLAY, payload });
                    return;
                case 'Ya existe una empresa similar':
                    Alert.error(I18nUtils.tr('TR_YA_EXISTE_UNA_EMPRESA_SIMILAR_PARA_SU_CONTRATISTA'));
                    return;
                default:
                    Alert.error(error || I18nUtils.tr('TR_ADD_OUTSOURCE_ERROR'));
            }
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: false });
        })
        .execute();
};

export const updateCompany = (company = {}, redirect = false) => (dispatch) => {

    const companySave = {
        id: company.id,
        name: company.name,
        nif: company.nif,
        contact_person: company.contact_person,
        phone: company.phone,
        email: company.email,
        address: company.address,
        ccc: company.ccc,
        disabled: !company.enabled,
        document_schema_id: company.document_schema_id && company.document_schema_id.length !== 0 ? company.document_schema_id[0].value : undefined,
        document_schema_monthly_id: company.document_schema_monthly_id && company.document_schema_monthly_id.length !== 0 ? company.document_schema_monthly_id[0].value : undefined,
        user_email: undefined,
        user_plain_password: undefined,
    };

    new UpdateCompanyRequest(company.id, companySave)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: true });
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_UPDATE_OUTSOURCE_SUCCESS'));
            dispatch({
                type: OUTSOURCE_UPDATE,
                payload: data,
            });
            if ( redirect ) {
                dispatch(push(PsRoutes.MY_OUTSOURCES));
            }
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_OUTSOURCE_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCE_LOADING, payload: false });
        })
        .execute();
};

export const getCompanyWorks = (companyId, presenceTypeId, levelTypeId, notCheckPresenciaObra = false) => (dispatch) => {
    new CompanyWorksRequest(companyId, presenceTypeId, levelTypeId, notCheckPresenciaObra)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCE_WORKS_LOADING, payload: true });
        })
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: OUTSOURCE_WORKS_UPDATE,
                payload: response.data,
            });
        })
        .onPostExecution(() => {
            dispatch({ type: OUTSOURCE_WORKS_LOADING, payload: false });
        })
        .execute();
};

export const setAssignmentModalVisibility = (displayDialog) => (dispatch) => {
    const payload = { displayDialog };
    dispatch({ type: OUTSOURCE_ASSIGNMENT_DISPLAY, payload });
};

export const addCompanyAssociation = (nif, documentSchemaId, documentSchemaMonthlyId) => (dispatch) => {
    new CompanyAssociationAdd(nif, documentSchemaId, documentSchemaMonthlyId)
        .onPreExecution(() => {
            dispatch({ type: OUTSOURCE_ASSIGNMENT_LOADING, payload: true });
            dispatch({ type: OUTSOURCE_ASSIGNMENT_DISPLAY, payload: { displayDialog: false } });
        })
        .onSuccess(() => {
            Alert.success(I18nUtils.tr('TR_ADD_OUTSOURCE_SUCCESS'));
            dispatch(push(PsRoutes.MY_OUTSOURCES));
        })
        .onFail((error) => Alert.error(error || I18nUtils.tr('TR_ADD_OUTSOURCE_ERROR')))
        .onPostExecution(() => dispatch({ type: OUTSOURCE_ASSIGNMENT_LOADING, payload: false }))
        .execute();

};

export const cleanOutsourceWorks = () =>(dispatch) => {
    dispatch({ type: OUTSOURCE_WORKS_CLEAN})
}



// WEBPACK FOOTER //
// ./src/app/outsource/actions/outsourceActions.js